import { render } from "./team.vue?vue&type=template&id=5f24cab3&scoped=true"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=5f24cab3&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f24cab3"]])

export default __exports__